<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>Olá! Vamos começar sua autoavaliação comportamental?</h2>
    </div>

    <div>
      <h2>Analise os comportamentos</h2>
      <p>
        Os comportamentos aparecerão na sua tela. Ao lado de cada um, aparecerá
        uma escala que vai de
        <span class="text-center info--text font-weight-medium text-lg-h6">"Nunca"</span>
        <span class="text-center font-weight-medium text-lg-h6"> a </span>
        <span class="text-center info--text font-weight-medium text-lg-h6">"Sempre"</span>
        <span class="text-center font-weight-medium text-lg-h6">.</span>
      </p>
    </div>

    <div>
      <h2>Selecione a frequência dos comportamentos</h2>
      <p>
        Clique na estrela que representa a frequência que você apresentou o
        comportamento indicado durante os últimos doze meses.
      </p>
    </div>

    <div>
      <h2>Importante!</h2>
      <p>
        <span class="info--text">
          Lembre-se! Essa avaliação ajudará a direcionar sua trilha de
          desenvolvimento.
        </span>
      </p>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialAutoavaliacao',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Comportamentos', 'Frequência dos comportamentos', 'Importante'],
    };
  },
};
</script>
